var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { collectionEngineV1, IAM } from '../apis';
const authAPI = collectionEngineV1('/tenants', false);
const reqIAM = IAM('/tenants', false);
export const createNewTenant = (newTenant) => authAPI('POST', `/`, {
    body: newTenant,
});
export const getAll = () => __awaiter(void 0, void 0, void 0, function* () { return reqIAM('GET', '/?offset=0&limit=5000'); });
export const get = (id) => __awaiter(void 0, void 0, void 0, function* () { return reqIAM('GET', `/${id}`); });
export const update = (id, tenant) => reqIAM('PATCH', `/${id}`, {
    body: tenant,
});
//# sourceMappingURL=tenants.js.map